// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2FTRa","heading":"layout-module--heading--1q93M"};